module.exports = __webpack_public_path__ + "img/item-left.9c5b19ad.png";